module.exports = __webpack_public_path__ + "img/administration.02177e77.png";